import { useEffect, useState } from 'react';
import { useBranchId } from './use-branch-id';
import { cdnQuery } from '../components/utilities/cdnQuery';

export const useSalesRepBio = () => {
	const branchId = useBranchId();
	const [salesRepBio, setSalesRepBio] = useState(null);
	const [status, setStatus] = useState('loading');

	const fetchBioFromContentstack = (branchID) => {
		const query = `{
            "inhome": { "$eq": true },
            "$or": [
                {
                    "branch_data": {
                        "$in_query": {
                            "branch_retail": {
                                "$in": ${JSON.stringify([branchID])}
                            }
                        }
                    }
                }
            ]
        }`;

		cdnQuery('author', query, 'include[]=author_bio&include[]=image&include[]=branch_data&include[]=branch_data.local_nav.cta')
			.then((response) => {
				setStatus('success');
				setSalesRepBio(response.data.entries[0]);
			})
			.catch(() => {
				setStatus('error');
			});
	};

	useEffect(() => {
		if (!branchId) return;
		fetchBioFromContentstack(branchId);
	}, [branchId]);

	return { salesRepBio, status };
};
